export enum CurrencyType {
  BRL = 'BRL',
  USD = 'USD',
}
